import { ProductVariantInterface } from 'common/types/entities/ProductInterface'
import { SelectedShipping } from 'common/types/entities/ShippingFeesInterface'
import { OfferPricing } from 'common/types/pricingTypes'
import {
  DECREASE_PRODUCT_QUANTITY,
  INCREASE_PRODUCT_QUANTITY,
  INITIALIZE_PRODUCT_QUANTITY,
  SET_ACTIVE_PRICE_PLAN_ID,
  SET_ACTIVE_PRODUCT_VARIANT,
  SET_DLOCAL_DOCUMENT_NUMBER,
  TOGGLE_CHECKED_BUMP,
  SET_OFFER_PRICING,
  SET_SELECTED_SHIPPING,
  UPDATE_COUPON,
  CHECK_COUPON_SUCCESS,
  CHECK_COUPON_FAIL,
  SET_STRIPE_PAYMENT_METHOD,
} from './paymentActionTypes'
import { Coupon } from 'common/types/CouponType'

export function setDlocalDocumentNumber(value: string) {
  return {
    payload: value,
    type: SET_DLOCAL_DOCUMENT_NUMBER,
  }
}

export function setActivePricePlanId(pricePlanId: number) {
  return {
    payload: pricePlanId,
    type: SET_ACTIVE_PRICE_PLAN_ID,
  }
}

export function initializeProductQuantity(quantity: number) {
  return {
    payload: quantity,
    type: INITIALIZE_PRODUCT_QUANTITY,
  }
}

export function increaseProductQuantity() {
  return {
    type: INCREASE_PRODUCT_QUANTITY,
  }
}

export function decreaseProductQuantity() {
  return {
    type: DECREASE_PRODUCT_QUANTITY,
  }
}

export function setProductActiveVariant(
  productVariant: ProductVariantInterface,
) {
  return {
    type: SET_ACTIVE_PRODUCT_VARIANT,
    payload: productVariant,
  }
}

export const setOfferPricing = (offerPricing: OfferPricing[]) => {
  return {
    type: SET_OFFER_PRICING,
    payload: offerPricing,
  }
}

export const setStripePaymentMethod = (paymentMethod: string) => {
  return {
    type: SET_STRIPE_PAYMENT_METHOD,
    payload: paymentMethod,
  }
}

export function setSelectedShipping(selectedShipping: SelectedShipping | null) {
  return {
    type: SET_SELECTED_SHIPPING,
    payload: selectedShipping,
  }
}

export function toggleCheckedBump() {
  return {
    type: TOGGLE_CHECKED_BUMP,
  }
}

export function checkedCouponSuccess(coupon: Coupon) {
  return {
    type: CHECK_COUPON_SUCCESS,
    payload: coupon,
  }
}

export function checkedCouponFail(error: unknown) {
  return {
    type: CHECK_COUPON_FAIL,
    payload: error,
  }
}

export function updateCoupon(code: string) {
  return {
    type: UPDATE_COUPON,
    payload: code,
  }
}
